import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export const AMSCustomColumnsSettingsRoutes = {
    [`/manage_ams_columns/${hmapPathParamRegex}?brand_id&template_id&view_only`]: {
        "name": "appLayout.harriSH.access-portal.settings.create-ams-columns-settings",
        "params": {
            ...hmapPathParamConfig
        },
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": "amsColumnsSetupWizardContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['ams_columns_settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./ams-columns-settings.module.js");
                }
            },
        ]
    },
    "/manage_ams_columns?brand_id&template_id&view_only": {
        "name": "appLayout.harriSH.create-ams-columns-settings",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": "amsColumnsSetupWizardContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['ams_columns_settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./ams-columns-settings.module.js");
                }
            },
        ]
    },
};